import { render, staticRenderFns } from "./ModalPop.vue?vue&type=template&id=6a0a5284&scoped=true&"
import script from "./ModalPop.vue?vue&type=script&lang=js&"
export * from "./ModalPop.vue?vue&type=script&lang=js&"
import style0 from "./ModalPop.vue?vue&type=style&index=0&id=6a0a5284&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0a5284",
  null
  
)

export default component.exports